Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.PostsView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/campaign/section']

  initialize: (@options = {}) =>
    @postsRendered = parseInt(@options.postsRendered)
    @maxPostCount =  parseInt(@options.maxPostCount)

  render: ->
    @$el.html(@template(@options))
    @$el.addClass(@options.section + '-contents-section')
    @$el.addClass('any-section')

    @pending = @options.posts.length
    posts = @options.selected_posts
    posts.sort (a,b) ->
      sortBy('date', a, b) 

    for post in posts
      if @postsRendered < @maxPostCount
        params = $.extend({}, @options, {post:post, type: post.type, user: post.user, summary: false, content_id: post.content_id})
        if post.type == "facebook"
          section = new Monitoring.Reports.Campaign.FacebookPostView(params)
        else if post.type == "twitter"
          section = new Monitoring.Reports.Campaign.TwitterPostView(params)
        else
          section = new Monitoring.Reports.Campaign.InstagramPostView(params)

        section.bind('rendered', @_sectionRendered)
        section.render()
        @$('.data').append(section.el)
        @postsRendered++

  _sectionRendered: =>
    @pending -= 1
    @trigger('rendered') if @pending == 0

  sortBy = (key, a, b) ->
    return +1 if a[key] > b[key]
    return -1 if a[key] < b[key]
    return 0

